export interface ISocialMediaState {
    isLoading: boolean;
    callbackData: ISocialMediaResponse;
}

export const REQUEST_SOCIAL_MEDIA = "REQUEST_SOCIAL_MEDIA";
export const RECEIVE_SOCIAL_MEDIA = "RECEIVE_SOCIAL_MEDIA";

export interface IRequesSocialMediaAction {
    type: typeof REQUEST_SOCIAL_MEDIA;
}

export interface IReceiveSocialMediaAction {
    type: typeof RECEIVE_SOCIAL_MEDIA;
    callbackData: ISocialMediaResponse;
}

export type SocialMediaTypes = IRequesSocialMediaAction | IReceiveSocialMediaAction;

export interface ISocialMediaResponse {
    scope?: string;
    code?: string;
    account_number?: string;
    token?: string;
    token_expiration?: string;
    network?: string;
    secret?: string;
    refresh_token?: string;
}
